import React from 'react'

import HintPopover from "../../../gd-ui/hint-popover/hint-popover"
import PopoverSelectorMenu from "./popover-menu"
import ErrorBoundary from "../../../error-boundary"
import PopoverSelectorButtonControlMain from "./buttons/control-main"
import PopoverSelectorButtonControlMainIcon from "./buttons/control-main-icon"
import PopoverSelectorButtonControlIcon from "./buttons/control-icon"
import PopoverSelectorButtonControlMainLabelIcon from "./buttons/control-main-icon-no-border"
import {findDOMNode} from "react-dom";
import PopoverV2 from "../../gd-popover/popover-v2";
import PopoverPosition from "../../gd-popover/popover-position";
import PopoverMenu from "../../popover-menu/popover-menu/popover-menu";

export type PopoverSelector_ButtonPayload = {
    isSelected      : boolean,
    onClick         : callback
}



type Props = {

    className?          : string        //
    style?              : style         //

    // The button (!)
    button              : { (isSelected:boolean, onClick:callback): React.ReactNode }

    // menu options
    options             : Option[],

    // defaultHelpMessage? : string,      // default help message

    onChange?           : callback,           // main value callback
    onTogglePopover?    : callback,
}

type State = {
    showPopover : boolean
}

/*

This is new component that replaces selector-with-info
helpMessage (options hints) checked dynamicly if not passed nothing will show up

 */
export default class PopoverSelectorNew extends React.Component<Props, State> {

    // hasHelp     : boolean

    // static defaultProps = {
    //     attachment: 'top center',
    //     targetAttachment: 'bottom center',
    //     style: {}
    // };

    constructor(props:Props) {
        super(props);

        this.state = {
            showPopover: false
        }

        // this.state = _.assign(this.state, {
        //     showPopover: false
        // });

        // detect if help message needed
        // this.hasHelp = !!this.props.defaultHelpMessage

        // _.map(this.props.options, option=>{
        //     if (!!option.helpMessage) this.hasHelp = true
        // })
        // end


    }

    showPopover = (e?:React.SyntheticEvent, callback?:callback) => {
        if (e) e.stopPropagation();

        this.setState({
            showPopover: true
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(true);
            if (callback) callback();
        })
    }

    hidePopover = (e?:React.SyntheticEvent, callback?:callback) => {
        if (e) e.stopPropagation();
        this.setState({
            showPopover: false
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(false);
            if (callback) callback();
        })
    }

    togglePopover = (e:React.SyntheticEvent, callback?:callback) => {
        if (e) e.stopPropagation();

        if (this.state.showPopover) {
            this.hidePopover(e, callback)
        } else {
            this.showPopover(e, callback)
        }

    }

    onOptionClick = (option:Option) => {
        this.hidePopover(undefined,()=>{
            if (this.props.onChange) this.props.onChange(option.value);
        });
    };

    render() {

        const classes = Classes(this.props.className, {
            // "is-selected": !!this.props.value
        });

        // // @ts-ignore
        // const ButtonComponent = mapButtomComponent[this.props.buttonType]
        //
        // if (!ButtonComponent) {
        //     return <div>ERROR #485-2322 - no button type specified or component found</div>
        // }

        const button = this.props.button(this.state.showPopover, this.togglePopover)

        const popoverPosition       = PopoverPosition.bottomCenter()

        // we need top div so popover used it as a target


        return (
            // @ts-ignore
            <div className={classes}>
                {button}
                {this.state.showPopover &&
                    <PopoverV2  position                   = {popoverPosition}
                                className                  = "min-w-250"
                                // popoverClass               = "gd-select-parent-popover-new"
                                // getTargetFunc              = {()=>findDOMNode(button)}
                                outsideClickIgnoreClass    = "option"
                                onClickOutside             = {this.hidePopover}>

                        <PopoverMenu options={this.props.options} hidePopover={this.hidePopover} />

                    </PopoverV2>

                    // <PopoverSelectorMenu parent={this} selectedOption={selectedOption} />
                }
            </div>
        )

    }
}